import { render, staticRenderFns } from "./employee-profile.vue?vue&type=template&id=3ff13347&scoped=true&"
import script from "./employee-profile.vue?vue&type=script&lang=js&"
export * from "./employee-profile.vue?vue&type=script&lang=js&"
import style0 from "./employee-profile.css?vue&type=style&index=0&id=3ff13347&prod&scoped=true&lang=css&"
import style1 from "./employee-profile.vue?vue&type=style&index=1&id=3ff13347&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff13347",
  null
  
)

export default component.exports